import {
  WIDGET_ANALYTICS_SCHEMA_VERSION,
  type WidgetAnalyticsEnvelope,
  type WidgetAnalyticsEvent,
  type WidgetAnalyticsEventName,
  type WidgetBuildInfo,
} from './types';

interface BuildAnalyticsEnvelopeOptions<
  TName extends WidgetAnalyticsEventName = WidgetAnalyticsEventName,
> {
  tenant: string;
  buildInfo: WidgetBuildInfo;
  event: WidgetAnalyticsEvent<TName>;
  emittedAt?: string;
}

/**
 * Create a full WidgetAnalyticsEnvelope from event data
 */
export function buildAnalyticsEnvelope<TName extends WidgetAnalyticsEventName>({
  tenant,
  buildInfo,
  event,
  emittedAt = new Date().toISOString(),
}: BuildAnalyticsEnvelopeOptions<TName>): WidgetAnalyticsEnvelope<TName> {
  return {
    schemaVersion: WIDGET_ANALYTICS_SCHEMA_VERSION,
    name: event.name,
    emittedAt,
    tenant,
    activity: event.activity,
    page: event.page,
    widgetVersion: buildInfo.version,
    payload: event.payload,
  };
}
